<template>
  <div class="relative bg-white pt-16 pb-16">
    <div class="px-4 md:px-10 mx-auto w-full">
      <!-- Table -->
      <div class="flex flex-wrap mt-6">
        <div class="w-full px-4">
          <div
            class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white"
          >
            <div class="rounded-t mb-0 px-6 py-3 border-0">
              <div class="flex flex-wrap items-center">
                <div class="relative w-full px-4 max-w-full flex-grow flex-1">
                  <h3 class="font-semibold text-base text-blueGray-700">
                    认证申请
                  </h3>
                </div>
              </div>
            </div>
            <div class="block w-full px-6 pb-6">
              <el-form
                :inline="true"
                :model="formInline"
                class="demo-form-inline"
              >
                <el-form-item label="用户名">
                  <el-input
                    v-model="formInline.username"
                    placeholder="请输入用户名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="邮箱">
                  <el-input
                    v-model="formInline.email"
                    placeholder="请输入邮箱"
                  ></el-input>
                </el-form-item>
                <el-form-item label="电话">
                  <el-input
                    v-model="formInline.phone"
                    placeholder="请输入电话"
                  ></el-input>
                </el-form-item>
                <el-form-item label="UnionID">
                  <el-input
                    v-model="formInline.unionid"
                    placeholder="请输入 UnionID"
                  ></el-input>
                </el-form-item>
                <el-form-item label="申请类型">
                  <el-select
                    v-model="formInline.type"
                    clearable
                    placeholder="请选择申请类型"
                    style="width: 160px"
                  >
                    <el-option label="个人认证" value="1"></el-option>
                    <el-option label="企业认证" value="2"></el-option>
                    <el-option label="组织认证" value="3"></el-option>
                    <el-option label="公众号认证" value="4"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="状态">
                  <el-select
                    v-model="formInline.status"
                    clearable
                    placeholder="请选择状态"
                    style="width: 140px"
                  >
                    <el-option label="全部" value="-1"></el-option>
                    <el-option label="待审核" value="1"></el-option>
                    <el-option label="已通过" value="2"></el-option>
                    <el-option label="已拒绝" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="申请时间">
                  <el-date-picker
                    v-model="formInline.createTime"
                    type="date"
                    placeholder="请选择申请时间"
                    value-format="YYYY-MM-DD"
                    style="width: 180px"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSearch">查询</el-button>
                  <el-button @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
              <div class="block w-full overflow-x-auto">
                <el-table
                  :data="applications"
                  style="width: 100%; min-width: 1200px"
                  :default-sort="{ prop: 'createdAt', order: 'descending' }"
                  stripe
                  border
                  highlight-current-row
                >
                  <el-table-column label="运营人/主体" width="150">
                    <template #default="scope">
                      <p class="text-sm">{{ scope.row.username }}</p>
                      <p class="font-semibold text-sm">
                        {{ scope.row.full_name }}
                      </p>
                      <p
                        v-if="scope.row.type == 4"
                        class="text-sm"
                        color="#FF0011"
                      >
                        验证码:{{ scope.row.auth_code }}
                      </p>
                    </template>
                  </el-table-column>

                  <el-table-column label="申请类型" width="120">
                    <template #default="scope">
                      <el-tag
                        :type="getTypeTagType(scope.row.type)"
                        size="small"
                      >
                        {{ getTypeLabel(scope.row.type) }}
                      </el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column label="Unionid" width="150">
                    <template #default="scope">
                      <p class="text-sm">{{ scope.row.id }}</p>
                    </template>
                  </el-table-column>

                  <el-table-column label="电话" width="150">
                    <template #default="scope">
                      <p class="text-sm">{{ scope.row.op_phone }}</p>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="createdAt"
                    label="申请时间"
                    width="180"
                    sortable
                  >
                    <template #default="scope">
                      {{ formatDate(scope.row.createdAt) }}
                    </template>
                  </el-table-column>

                  <el-table-column label="状态" width="100">
                    <template #default="scope">
                      <el-tag
                        :type="getStatusTagType(scope.row.status)"
                        size="small"
                      >
                        {{ getStatusLabel(scope.row.status) }}
                      </el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="createdAt"
                    label="审核"
                    width="180"
                    sortable
                  >
                    <template #default="scope">
                      {{ formatDate(scope.row.auth_time) }}
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" fixed="right">
                    <template #default="scope">
                      <el-button
                        type="primary"
                        size="small"
                        @click="viewDetail(scope.row)"
                      >
                        查看
                      </el-button>
                      <el-button
                        v-if="
                          scope.row.status === 1 &&
                          (scope.row.type !== 'official_account' ||
                            isApplicationVerified(scope.row))
                        "
                        type="success"
                        size="small"
                        @click="approveApplication(scope.row)"
                      >
                        通过
                      </el-button>
                      <el-button
                        v-if="
                          scope.row.status === 1 &&
                          (scope.row.type !== 'official_account' ||
                            isApplicationVerified(scope.row))
                        "
                        type="danger"
                        size="small"
                        @click="rejectApplication(scope.row)"
                      >
                        拒绝
                      </el-button>
                      <el-button
                        v-if="
                          scope.row.status === 1 &&
                          scope.row.type === 'official_account' &&
                          !isApplicationVerified(scope.row)
                        "
                        type="warning"
                        size="small"
                        @click="openSmsModal(scope.row)"
                      >
                        发送短信验证
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <el-pagination
                :current-page="currentPage"
                :page-size="itemsPerPage"
                :page-sizes="[10, 20, 50, 100]"
                :total="totalRecords"
                layout="total, sizes, prev, pager, next, jumper"
                total-text="总记录数"
                prev-text="上一页"
                next-text="下一页"
                :pager-count="7"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                class="verification-pagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Application Detail Modal -->
    <el-dialog
      v-model="showModal"
      title="申请详情"
      width="600px"
      :before-close="closeModal"
      class="responsive-modal"
    >
      <div v-if="selectedApplication" class="space-y-6">
        <div class="grid grid-cols-2 gap-6 mb-6">
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >运营人员姓名</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{ selectedApplication.username }}
            </p>
          </div>
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >UnionID</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{ selectedApplication.id }}
            </p>
          </div>
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >联系电话</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{ selectedApplication.op_phone || "未提供" }}
            </p>
          </div>
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >申请类型</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{ getTypeLabel(selectedApplication.type) }}
            </p>
          </div>
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >申请时间</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{ formatDate(selectedApplication.createdAt) }}
            </p>
          </div>
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >审核时间</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{
                selectedApplication.auth_time
                  ? formatDate(selectedApplication.auth_time)
                  : "未审核"
              }}
            </p>
          </div>
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >当前状态</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{ getStatusLabel(selectedApplication.status) }}
            </p>
          </div>

          <div class="space-y-2" v-if="selectedApplication.status == 3">
            <label class="block text-sm font-semibold text-gray-800"
              >拒绝理由</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{ selectedApplication.reason || "暂无备注信息" }}
            </p>
          </div>
        </div>

        <div
          v-if="
            selectedApplication.documents &&
            selectedApplication.documents.length > 0
          "
          class="space-y-2"
        >
          <label class="block text-sm font-semibold text-gray-800"
            >相关凭证</label
          >
          <div class="space-y-2">
            <div
              v-for="doc in selectedApplication.documents"
              :key="doc.id"
              class="flex items-center justify-between bg-gray-50 px-3 py-2 rounded-md"
            >
              <div class="flex items-center gap-2">
                <span class="text-blue-500">📄</span>
                <span class="text-sm text-gray-700">{{ doc.name }}</span>
              </div>
              <el-link
                :href="doc.url"
                target="_blank"
                type="primary"
                size="small"
              >
                查看
              </el-link>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeModal">关闭</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- Reject Reason Modal -->
    <el-dialog
      v-model="showRejectModal"
      title="拒绝理由"
      width="520px"
      :before-close="closeRejectModal"
      class="responsive-modal"
    >
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-2"
          >请输入拒绝此申请的理由：</label
        >
        <el-input
          v-model="rejectReason"
          type="textarea"
          :rows="5"
          placeholder="例如：资料不完整，无法核验身份"
          :maxlength="500"
          show-word-limit
        />
        <p v-if="rejectError" class="text-red-500 text-sm mt-2">
          {{ rejectError }}
        </p>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeRejectModal">取消</el-button>
          <el-button type="danger" @click="confirmReject">确认拒绝</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- SMS Verification Modal -->
    <el-dialog
      v-model="showSmsModal"
      title="短信验证"
      width="500px"
      :before-close="closeSmsModal"
      class="responsive-modal"
    >
      <div v-if="smsTargetApp" class="space-y-4">
        <div class="mb-4">
          <p class="text-sm text-gray-600 mb-2">
            正在为
            <strong>{{ smsTargetApp.username }}</strong>
            的公众号认证申请进行短信验证
          </p>
          <p class="text-sm text-gray-500">
            手机号：{{ smsTargetApp.phone || "未提供手机号" }}
          </p>
        </div>

        <div v-if="!isSmsSent">
          <el-button
            type="primary"
            @click="sendSmsVerification"
            :loading="loading"
            class="w-full"
          >
            发送验证码
          </el-button>
        </div>

        <div v-else>
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              请输入收到的验证码：
            </label>
            <el-input
              v-model="verificationCode"
              placeholder="请输入6位验证码"
              :maxlength="6"
              @keyup.enter="verifyCode"
            />
            <p v-if="smsCountdown > 0" class="text-sm text-gray-500 mt-2">
              {{ smsCountdown }}秒后可重新发送
            </p>
            <p v-else class="text-sm text-gray-500 mt-2">
              <el-link type="primary" @click="sendSmsVerification"
                >重新发送验证码</el-link
              >
            </p>
          </div>

          <p v-if="smsError" class="text-red-500 text-sm mb-4">
            {{ smsError }}
          </p>

          <el-button
            type="primary"
            @click="verifyCode"
            :loading="loading"
            class="w-full"
          >
            验证
          </el-button>
        </div>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeSmsModal">取消</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<style scoped>
@media (max-width: 768px) {
  .responsive-modal :deep(.el-dialog) {
    width: 90vw !important;
    max-width: 90vw !important;
    margin: 5vh auto !important;
    max-height: 90vh !important;
    overflow-y: auto !important;
  }

  .responsive-modal :deep(.el-dialog__body) {
    padding: 16px !important;
    max-height: calc(90vh - 120px) !important;
    overflow-y: auto !important;
  }

  .responsive-modal :deep(.el-dialog__header) {
    padding: 16px 16px 12px !important;
  }

  .responsive-modal :deep(.el-dialog__footer) {
    padding: 12px 16px 16px !important;
  }
}

@media (max-width: 480px) {
  .responsive-modal :deep(.el-dialog) {
    width: 95vw !important;
    max-width: 95vw !important;
    margin: 2vh auto !important;
  }

  .responsive-modal :deep(.el-dialog__body) {
    padding: 12px !important;
  }
}

.verification-pagination {
  margin-top: 16px;
  justify-content: flex-start;
}
</style>

<script>
import { getAdminApiUrl } from "@/api/luckdraw.js";
import { getUserToken } from "@/utils/auth.js";
import {
  buildVerificationAuditRequest,
  normalizeVerificationApplication,
} from "./verificationPresenter.js";

export default {
  name: "Verification",
  data() {
    return {
      applications: [],
      filteredApplications: [],
      formInline: {
        username: "",
        email: "",
        phone: "",
        unionid: "",
        type: "",
        status: "1",
        createTime: "",
      },
      currentPage: 1,
      totalRecords: 0,
      itemsPerPage: 10,
      showModal: false,
      selectedApplication: null,
      loading: false,
      showRejectModal: false,
      rejectReason: "",
      rejectError: "",
      rejectTargetApp: null,
      showSmsModal: false,
      smsTargetApp: null,
      verificationCode: "",
      smsError: "",
      isSmsSent: false,
      smsCountdown: 0,
      verifiedApplications: new Set(),
    };
  },
  computed: {
    totalApplications() {
      return this.applications.length;
    },
    pendingApplications() {
      return this.applications.filter((app) => app.status === 1).length;
    },
    approvedApplications() {
      return this.applications.filter((app) => app.status === 2).length;
    },
    rejectedApplications() {
      return this.applications.filter((app) => app.status === 3).length;
    },
    totalPages() {
      return Math.ceil(this.totalRecords / this.itemsPerPage);
    },
    paginatedApplications() {
      return this.applications;
    },
    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
  },
  mounted() {
    this.loadApplications(this.getFilters());
  },
  methods: {
    getFilters() {
      return {
        username: this.formInline.username,
        email: this.formInline.email,
        phone: this.formInline.phone,
        unionid: this.formInline.unionid,
        type: this.formInline.type,
        status: this.formInline.status,
        createTime: this.formInline.createTime,
      };
    },
    async loadApplications(filters = {}) {
      this.loading = true;

      try {
        // 获取认证申请列表API
        const token = getUserToken();
        const url = new URL(
          getAdminApiUrl('/auth/list')
        );
        url.searchParams.append("page", this.currentPage);
        url.searchParams.append("limit", this.itemsPerPage);

        // 添加筛选参数
        if (filters.status && filters.status !== "-1") {
          url.searchParams.append("status", filters.status);
        }
        if (filters.type) {
          url.searchParams.append("type", filters.type);
        }
        if (filters.username) {
          url.searchParams.append("op_name", filters.username);
        }
        if (filters.email) {
          url.searchParams.append("email", filters.email);
        }
        if (filters.phone) {
          url.searchParams.append("op_phone", filters.phone);
        }
        if (filters.unionid) {
          url.searchParams.append("unionid", filters.unionid);
        }
        if (filters.createTime) {
          // 日期格式: YYYY-MM-DD HH:mm
          url.searchParams.append(
            "start_time",
            filters.createTime + " 00:00:00"
          );
          url.searchParams.append("end_time", filters.createTime + " 23:59:59");
        }

        const response = await fetch(url.toString(), {
          method: "GET",
          headers: {
            Token: `${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error(`获取申请列表失败: ${response.status}`);
        }

        const result = await response.json();

        if (result.sta === 0 && result.data.list) {
          this.totalRecords = result.data.count;
          // 转换API响应数据格式到前端格式
          this.applications = result.data.list.map(
            normalizeVerificationApplication
          );
        } else {
          throw new Error(result.msg || "获取申请列表失败");
        }
      } catch (error) {
        console.error("加载认证申请失败:", error);
        // 失败时使用模拟数据作为fallback
        this.applications = [
          {
            id: 1,
            username: "张三",
            email: "zhangsan@example.com",
            avatar: "https://via.placeholder.com/40x40/4F46E5/FFFFFF?text=张",
            type: "individual",
            status: "pending",
            createdAt: "2024-01-15T10:30:00Z",
            reason: "个人身份认证申请",
            documents: [
              { id: 1, name: "身份证正面.jpg", url: "#" },
              { id: 2, name: "身份证反面.jpg", url: "#" },
            ],
          },
          {
            id: 24,
            username: "公众号用户",
            email: "official@example.com",
            phone: "13800138000",
            avatar: "https://via.placeholder.com/40x40/3B82F6/FFFFFF?text=公",
            type: "official_account",
            status: "pending",
            createdAt: "2024-01-16T09:00:00Z",
            reason: "公众号认证申请",
            documents: [{ id: 25, name: "公众号认证资料.pdf", url: "#" }],
          },
        ];

        this.$message.error("加载认证申请失败，使用演示数据");
      } finally {
        this.filteredApplications = [...this.applications];
        this.loading = false;
      }
    },

    onSearch() {
      this.currentPage = 1;
      this.loadApplications(this.getFilters());
    },
    onReset() {
      this.formInline = {
        username: "",
        email: "",
        phone: "",
        unionid: "",
        type: "",
        status: "1",
        createTime: "",
      };
      this.currentPage = 1;
      this.loadApplications(this.getFilters());
    },

    getTypeLabel(type) {
      const typeMap = {
        1: "个人认证",
        2: "企业认证",
        3: "组织认证",
        4: "公众号认证",
      };
      return typeMap[type] || type;
    },

    getStatusLabel(status) {
      const statusMap = {
        1: "待审核",
        2: "已通过",
        3: "已拒绝",
      };
      return statusMap[status] || status;
    },
    getTypeTagType(type) {
      const tagTypes = {
        1: "info",
        2: "primary",
        3: "primary",
        4: "success",
      };
      return tagTypes[type] || "info";
    },
    getStatusTagType(status) {
      const tagTypes = {
        1: "warning",
        2: "success",
        3: "danger",
      };
      return tagTypes[status] || "info";
    },

    formatDate(dateString) {
      const date = new Date(dateString * 1000);
      return date.toLocaleDateString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    viewApplication(application) {
      console.log("查看申请:", application);
      this.selectedApplication = application;
      this.showModal = true;
      console.log("模态框状态:", this.showModal);
    },

    viewDetail(application) {
      // 跳转到详情页
      this.$router.push(`/admin/customers/verification/${application.id}`);
    },

    closeModal() {
      console.log("关闭模态框");
      this.showModal = false;
      this.selectedApplication = null;
    },

    async approveApplication(application) {
      if (confirm(`确定要通过 ${application.username} 的认证申请吗？`)) {
        this.loading = true;

        try {
          const token = getUserToken();
          const auditRequest = buildVerificationAuditRequest(
            application,
            "passed"
          );
          const response = await fetch(
            auditRequest.endpoint,
            {
              method: "POST",
              headers: {
                Token: `${token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(auditRequest.body),
              credentials: "include",
            }
          );

          if (!response.ok) {
            throw new Error(`批准申请失败: ${response.status}`);
          }

          const result = await response.json();

          if (result.sta === 0) {
            application.status = 2;
            this.loadApplications(this.getFilters());
            this.$message.success("申请已通过！");
          } else {
            throw new Error(result.msg || "批准申请失败");
          }
        } catch (error) {
          console.error("批准申请失败:", error);
          this.$message.error("批准申请失败，请重试");
        } finally {
          this.loading = false;
        }
      }
    },

    // 打开拒绝理由模态框
    rejectApplication(application) {
      this.rejectTargetApp = application;
      this.rejectReason = "";
      this.rejectError = "";
      this.showRejectModal = true;
    },

    // 关闭拒绝理由模态框
    closeRejectModal() {
      this.showRejectModal = false;
      this.rejectReason = "";
      this.rejectError = "";
      this.rejectTargetApp = null;
    },

    // 确认拒绝
    async confirmReject() {
      if (!this.rejectReason || !this.rejectReason.trim()) {
        this.rejectError = "请输入拒绝理由";
        return;
      }
      if (!this.rejectTargetApp) {
        this.closeRejectModal();
        return;
      }

      this.loading = true;

      try {
        const token = getUserToken();
        const auditRequest = buildVerificationAuditRequest(
          this.rejectTargetApp,
          "rejected",
          this.rejectReason
        );
        const response = await fetch(
          auditRequest.endpoint,
          {
            method: "POST",
            headers: {
              Token: `${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(auditRequest.body),
            credentials: "include",
          }
        );

        if (!response.ok) {
          throw new Error(`拒绝申请失败: ${response.status}`);
        }

        const result = await response.json();

        if (result.sta === 0) {
          // 更新状态并记录拒绝理由
          this.rejectTargetApp.status = 3;
          this.rejectTargetApp.rejectReason = this.rejectReason.trim();
          this.loadApplications(this.getFilters());
          this.closeRejectModal();
          this.$message.success("申请已拒绝！");
        } else {
          throw new Error(result.msg || "拒绝申请失败");
        }
      } catch (error) {
        console.error("拒绝申请失败:", error);
        this.rejectError = "拒绝申请失败，请重试";
      } finally {
        this.loading = false;
      }
    },

    refreshData() {
      this.onReset();
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    goToPage(page) {
      this.currentPage = page;
    },
    onPageChange(page) {
      this.currentPage = page;
    },
    handleSizeChange(size) {
      this.itemsPerPage = size;
      this.currentPage = 1;
      this.loadApplications(this.getFilters());
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadApplications(this.getFilters());
    },

    // SMS Verification Methods
    openSmsModal(application) {
      this.smsTargetApp = application;
      this.showSmsModal = true;
      this.isSmsSent = false;
      this.verificationCode = "";
      this.smsError = "";
    },

    closeSmsModal() {
      this.showSmsModal = false;
      this.smsTargetApp = null;
      this.isSmsSent = false;
      this.verificationCode = "";
      this.smsError = "";
      this.smsCountdown = 0;
    },

    async sendSmsVerification() {
      if (!this.smsTargetApp || !this.smsTargetApp.phone) {
        this.smsError = "该申请未提供有效的手机号码";
        return;
      }

      this.loading = true;
      this.smsError = "";

      try {
        const token = getUserToken();
        const response = await fetch(
          getAdminApiUrl(`/verification/applications/${this.smsTargetApp.id}/send-sms`),
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            credentials: "include",
          }
        );

        if (!response.ok) {
          throw new Error(`发送验证码失败: ${response.status}`);
        }

        const result = await response.json();

        if (result.sta === 0) {
          this.isSmsSent = true;
          this.smsCountdown = 60;

          // 启动倒计时
          const countdownInterval = setInterval(() => {
            this.smsCountdown--;
            if (this.smsCountdown <= 0) {
              clearInterval(countdownInterval);
            }
          }, 1000);

          this.$message.success("验证码已发送到手机");
        } else {
          throw new Error(result.msg || "发送验证码失败");
        }
      } catch (error) {
        this.smsError = "发送验证码失败，请重试";
        console.error("发送短信失败:", error);
      } finally {
        this.loading = false;
      }
    },

    async verifyCode() {
      if (!this.verificationCode || this.verificationCode.length !== 6) {
        this.smsError = "请输入6位验证码";
        return;
      }

      this.loading = true;
      this.smsError = "";

      try {
        const token = getUserToken();
        const response = await fetch(
          getAdminApiUrl(`/verification/applications/${this.smsTargetApp.id}/verify-sms`),
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              code: this.verificationCode,
            }),
            credentials: "include",
          }
        );

        if (!response.ok) {
          throw new Error(`验证失败: ${response.status}`);
        }

        const result = await response.json();

        if (result.sta === 0) {
          this.verifiedApplications.add(this.smsTargetApp.id);
          this.$message.success("验证成功！现在可以审核此申请");
          this.closeSmsModal();
        } else {
          this.smsError = result.msg || "验证码错误，请重新输入";
        }
      } catch (error) {
        this.smsError = "验证失败，请重试";
        console.error("验证失败:", error);
      } finally {
        this.loading = false;
      }
    },

    isApplicationVerified(application) {
      return this.verifiedApplications.has(application.id);
    },
  },
};
</script>
